export default function WrapSupport({children}: { children: React.ReactNode }) {
	return <div className={`
		contents
		
		[&_.support-widget]:rounded-xl
		[&_.support-widget>div_.bg-gradient-to-r]:!bg-white
		[&_.support-widget>div_.bg-gradient-to-r]:!from-transparent
		[&_.support-widget>div_.bg-gradient-to-r]:!via-transparent
		[&_.support-widget>div_.bg-gradient-to-r]:!to-transparent
		[&_.support-widget>div_.bg-gradient-to-r_*]:!text-[#0E0E0E]
		
		[&_.support-widget>div_.bg-gradient-to-r]:!border-[1px]
		[&_.support-widget>div_.bg-gradient-to-r]:!border-[#DEDEDE] 
		[&_.support-widget>div_.bg-gradient-to-r]:!border-solid
		[&_.support-widget>div_.bg-gradient-to-r]:!border-x-0 
		[&_.support-widget>div_.bg-gradient-to-r]:!border-t-0 
		
		[&_.support-chat_.conversation-message]:!rounded-xl
		[&_.support-chat_.conversation-message]:!py-3
		[&_.support-chat_.conversation-message]:!px-5
		[&_.support-chat_.conversation-message-me]:!bg-[#2E2E2F]
		[&_.support-chat_.conversation-message-other]:!bg-[#F1F4F7]
		[&_.support-chat_.conversation-message-other]:!text-black
		
		[&_.support-widget>div]:!bg-white
		[&_.support-widget>div]:!via-transparent
		[&_.support-widget>div]:!to-transparent
		[&_.support-widget>div]:!from-transparent
		[&_.support-widget_.ant-upload>.anticon]:!invert
		[&_.support-widget_.ant-btn:not(.pointer-events-none)]:!bg-[#FFDD35]
		[&_.support-widget_.ant-btn:not(.pointer-events-none)]:!text-[#0E0E0E]
		[&_.support-widget_.ant-btn:not(.pointer-events-none)]:!border-none
		[&_.support-widget_.ant-btn:not(.pointer-events-none):hover]:!brightness-90
	`}>
		{children}
	</div>
}